import React from "react";
import GamesNavbar from "../games/components/GamesNavbar";

/**
 * Generic seat shell: handles loading/error for seat-level pages.
 */
export default function GameSeat({ room, loading, error, seatIndex, onBack, children }) {
  if (loading) {
    return (
      <div className="game-seat">
        <GamesNavbar />
        <div className="game-seat-content">
          <div className="loading-message">Loading game...</div>
        </div>
      </div>
    );
  }

  if (error || !room) {
    return (
      <div className="game-seat">
        <GamesNavbar />
        <div className="game-seat-content">
          <div className="error-message">
            <p>{error || "Room not found"}</p>
            {onBack && (
              <button className="btn-action" onClick={onBack}>
                Back to Room
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  const seat = seatIndex !== undefined ? room.data?.seats?.[seatIndex] : null;
  if (seatIndex !== undefined && (!seat || !seat.playerName)) {
    return (
      <div className="game-seat">
        <GamesNavbar />
        <div className="game-seat-content">
          <div className="error-message">
            <p>Seat {seatIndex + 1} is not occupied</p>
            {onBack && (
              <button className="btn-action" onClick={onBack}>
                Back to Room
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return children(room, seat);
}
